import { CandleMagnitudeLine } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/CandleMagnitudeLine';
import { CandleMagnitudeTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/exits/candleMagnitude/CandleMagnitudeTacticPanel';
import { AddCandleMagnitudeTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/AddCandleMagnitudeTacticPanel';
import { CandleMagnitudeWrapper } from '../../../../components/displays/tradeplans/softOrderModules/exitTacticModules/CandleMagnitudeModule/wrapper/CandleMagnitudeWrapper';
import CandleMagnitudeDocumentation from '../../../../components/forms/tradeplans/documentation/CandleMagnitudeDocumentation';
import CandleMagnitudeModule from '../../../../components/forms/tradeplans/tradingPlanFormComponents/FieldComponents/exitTactics/modules/CandleMagnitudeModule';
import { CandleMagnitudeData } from './candleMagnitudeData';
import { validateCandleMagnitude } from './validateCandleMagnitude';

export const CandleMagnitude = {
  //data class
  dataStore: CandleMagnitudeData,

  //string constants
  name: 'CANDLE_MAGNITUDE',
  tacticLabel: 'Candle Magnitude',
  addTacticLabel: 'Add Candle Magnitude',
  category: 'Exit',

  // components
  tradePlanFormModule: CandleMagnitudeModule,
  tacticPanel: CandleMagnitudeTacticPanel,
  addTacticPanel: AddCandleMagnitudeTacticPanel,
  wrapper: CandleMagnitudeWrapper,
  chartSoftOrderComponent: CandleMagnitudeLine,
  documentation: CandleMagnitudeDocumentation,
  alertDetailsComponent: null,

  //functions
  setupDetailParser: null,
  validationFunction: validateCandleMagnitude,
};
